import ms from 'ms';

import { type DataExportResultRequested } from './types';

/**
 * Query options that poll an export job every `interval` until it completes or
 * fails. A failed poll neither toasts nor reaches an error boundary, so the
 * caller reports the outcome itself.
 */
export function getExportResultPollingOptions(interval = ms('2s')) {
  return {
    meta: { suppressError: true },
    refetchInterval(query: { state: { data?: DataExportResultRequested } }) {
      if (['completed', 'failed'].includes(query.state.data?.status ?? '')) {
        return false;
      }

      return interval;
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    throwOnError: false,
  } as const;
}
